import styled from '../../../theme/styled-with-theme';
import { pxToRem } from '../../../styles/utils';
import { mediaQueries } from '../../../styles/media-queries';
import { BlockContainer, Column } from '../../Layout';

export const FooterWrapper = styled('footer')`
  max-width: ${pxToRem(1500)};
  margin: 0 auto;
`;

export const FooterBlockContainer = styled(BlockContainer)<{
  isAffiliate?: boolean;
}>`
  padding: ${({ theme, isAffiliate }) =>
    isAffiliate ? pxToRem(80) : theme.spacing.xl};
  padding-top: ${pxToRem(88)};

  ${mediaQueries[0]} {
    padding-left: ${pxToRem(40)};
    padding-right: ${pxToRem(40)};
  }

  ${mediaQueries.desktop} {
    padding: ${pxToRem(80)} ${pxToRem(40)};
  }
`;

export const FooterSocialColumn = styled(Column)<{ isAffiliate?: boolean }>`
  flex-direction: column;
  align-items: center;

  ${mediaQueries.desktop} {
    align-items: ${({ isAffiliate = false }) =>
      isAffiliate ? 'center' : 'flex-start'};
  }
`;

export const LineBreakWrapper = styled(Column)`
  display: block;

  ${mediaQueries.desktop} {
    display: none;
  }
`;

export const LineBreak = styled('hr')`
  ${({ theme }) => ({
    backgroundColor: theme.color.footerBgSecondary
  })}
  height: 2px;
  border: 0;
  width: 100%;
`;
